import routes from 'config/routes-constant';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import cookie from 'helper/cookie';
import Paths from 'helper/paths';
import Calculation from 'pages/Calculation';
import Dashboard from 'pages/Dashboard';
import Login from 'pages/Login';
import MyKides from 'pages/MyKides';
import Profile from 'pages/Profile';
import NewPassword from 'pages/Profile/newPassword';
import ResetPassword from 'pages/ResetPassword';
import Tickets from 'pages/Tickets';
import CreateTicket from 'pages/Tickets/Create';
import SingleTickets from 'pages/Tickets/SingleTicket';
import VerifyEmail from 'pages/VerifyEmail';
import ClaimMiles from 'pages/miles/Claim/index';
import NewMilage from 'pages/miles/New';
import ViewMiles from 'pages/miles/View';
import Services from 'pages/services';
import BuyMilage from 'pages/services/BuyMilage';
import HistoryDiscount from 'pages/services/Discount/History';
import DiscountBook from 'pages/services/Discount/book';
import { default as Discount } from 'pages/services/Discount/form';

import AwardTickets from 'pages/AwardTickets';
import FlightBook from 'pages/services/FreeTicket/book';
import FreeTicketResultPage from 'pages/services/FreeTicket/result';
import Products from 'pages/services/Products';
import CreateCard from 'pages/services/Products/cardFFp';
import Booking from 'pages/services/Products/productBooking';
import TransferMilage from 'pages/services/TransferMilage';
import ConvertMilage from 'pages/services/convertMilage';
import Signup from 'pages/signup';
const ProtectedRoute = ({ children }) => {
  const isLogin = !!cookie.get('authorization');

  if (!isLogin) return <Navigate to={Paths.Login.index().route} />;
  return children;
};

const Router: React.FC = () => {
  const langDetector = window.location.pathname.split('/')[2];
  const lang = ['fa', 'en'].includes(langDetector) ? langDetector : 'fa';
  return (
    <BrowserRouter basename={`/passenger/${lang}`}>
      <Routes>
        <Route path={routes.login} element={<Login />} />
        <Route path={routes.resetPassword} element={<ResetPassword />} />
        <Route path={routes.signup} element={<Signup />} />
        <Route path={routes.verifyEmail} element={<VerifyEmail />} />
        <Route
          path={routes.dashboard}
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path={routes.profile}
          element={
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          }
        />

        <Route
          path={routes.newPassword}
          element={
            <ProtectedRoute>
              <NewPassword />
            </ProtectedRoute>
          }
        />
        <Route
          path={routes.viewMiles}
          element={
            <ProtectedRoute>
              <ViewMiles />
            </ProtectedRoute>
          }
        />
        <Route
          path={routes.claimMiles}
          element={
            <ProtectedRoute>
              <ClaimMiles />
            </ProtectedRoute>
          }
        />
        <Route
          path={routes.newMilage}
          element={
            <ProtectedRoute>
              <NewMilage />
            </ProtectedRoute>
          }
        />
        <Route
          path={routes.buyMilage}
          element={
            <ProtectedRoute>
              <BuyMilage />
            </ProtectedRoute>
          }
        />
        {/* <Route
          path={routes.showHistory}
          element={
            <ProtectedRoute>
              <History />
            </ProtectedRoute>
          }
        /> */}
        <Route
          path={routes.convertMilage}
          element={
            <ProtectedRoute>
              <ConvertMilage />
            </ProtectedRoute>
          }
        />
        <Route
          path={routes.services}
          element={
            <ProtectedRoute>
              <Services />
            </ProtectedRoute>
          }
        />
        <Route
          path={routes.supervision}
          element={
            <ProtectedRoute>
              <MyKides />
            </ProtectedRoute>
          }
        />
        {/* <Route
          path={routes.freeTicket}
          element={
            <ProtectedRoute>
              <FreeTicket />
            </ProtectedRoute>
          }
        /> */}
        <Route
          path={routes.discount}
          element={
            <ProtectedRoute>
              <Discount />
            </ProtectedRoute>
          }
        />
        <Route
          path={routes.showHistoryDiscount}
          element={
            <ProtectedRoute>
              <HistoryDiscount />
            </ProtectedRoute>
          }
        />
        {/* <Route
          path={routes.products}
          element={
            <ProtectedRoute>
              <Products />
            </ProtectedRoute>
          }
        /> */}
        <Route
          path={routes.freeTicketBook}
          element={
            <ProtectedRoute>
              <FlightBook />
            </ProtectedRoute>
          }
        />
        <Route
          path={routes.discountBook}
          element={
            <ProtectedRoute>
              <DiscountBook />
            </ProtectedRoute>
          }
        />
        <Route
          path={routes.freeTicketReesult}
          element={
            <ProtectedRoute>
              <FreeTicketResultPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={routes.transferMilage}
          element={
            <ProtectedRoute>
              <TransferMilage />
            </ProtectedRoute>
          }
        />
        <Route
          path={routes.products}
          element={
            <ProtectedRoute>
              <Products />
            </ProtectedRoute>
          }
        />
        <Route
          path={routes.booking}
          element={
            <ProtectedRoute>
              <Booking />
            </ProtectedRoute>
          }
        />
        <Route
          path={routes.careteCard}
          element={
            <ProtectedRoute>
              <CreateCard />
            </ProtectedRoute>
          }
        />
        <Route
          path={routes.calculation}
          element={
            <ProtectedRoute>
              <Calculation />
            </ProtectedRoute>
          }
        />
        <Route
          path={routes.tickets}
          element={
            <ProtectedRoute>
              <Tickets />
            </ProtectedRoute>
          }
        />
        <Route
          path={routes.singleTicket}
          element={
            <ProtectedRoute>
              <SingleTickets />
            </ProtectedRoute>
          }
        />
        <Route
          path={routes.createTicket}
          element={
            <ProtectedRoute>
              <CreateTicket />
            </ProtectedRoute>
          }
        />
        <Route
          path={routes.awardTicket}
          element={
            <ProtectedRoute>
              <AwardTickets />
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
